"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkParticipation = function (value, valueToCheck) {
  if (typeof value !== 'number' && typeof value !== 'string') return false;
  if (typeof valueToCheck !== 'number' && typeof valueToCheck !== 'string') return false;
  var newValue = 0;
  if (typeof value === 'string' && !value.match(/^[0-9]{3}$/)) {
    var splitted = value.split('%');
    newValue = parseInt(splitted[0]);
  } else if (typeof value === 'number') {
    newValue = value;
  } else {
    newValue = parseInt(value);
  }
  if (newValue + valueToCheck > 100) return false;
  if (newValue > 100 || valueToCheck > 100) return false;
  return true;
};